import { render } from "./SalesPage.vue?vue&type=template&id=3155ea0c&scoped=true"
import script from "./SalesPage.vue?vue&type=script&lang=js"
export * from "./SalesPage.vue?vue&type=script&lang=js"

import "./SalesPage.vue?vue&type=style&index=0&id=3155ea0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3155ea0c"]])

export default __exports__